<template>
  <div>
    <b-card no-body class="px-4 mb-0 border-none">
      <div>
        <!-- <div>
          <feather-icon
            icon="ArrowLeftIcon"
            class="cursor-pointer text-muted"
            svgClasses="w-5"
          ></feather-icon>
        </div> -->
        <div class="mt-0">
          <p class="text-base font-semibold">
            {{ data.poll.question }}
          </p>
        </div>
        <!-- <div class="mt-2">
          <p class="text-sm font-normal leading-6 text-muted">
            {{ item.discussDescription }}
          </p>
        </div> -->
        <div class="poll-radio mt-5">
          <div v-for="choice in data.poll.choices" :key="choice._id" class="">
            <!-- 
              border mt-3 flex justify-between bg-f4f5f6 items-center <div
              :class="`py-3  bg-transparent`"
              :style="{
                width:
                  Math.round(choice.totalVotes / data.poll.totalVotes) * 100 +
                  '%',
              }"
            >
              <p class="text-lg font-medium pl-3">{{ choice.text }}</p>
            </div>
            <div class="">
              <p class="text-lg font-medium pr-3">
                {{
                  Math.round(choice.totalVotes / data.poll.totalVotes) * 100 ||
                  "0"
                }}%
              </p>
            </div> -->
            <b-progress class="cust-pb" height="2.5rem">
              <b-progress-bar :value="calculatePercent(choice.totalVotes)">
                <div
                  class="
                    flex
                    w-full
                    items-center
                    justify-between
                    absolute
                    text-primary
                  "
                >
                  <p class="pl-6 clr333 font-semibold">{{ choice.text }}</p>
                  <p class="pr-12 text-base font-semibold">
                    {{ calculatePercent(choice.totalVotes) || "0" }}%
                  </p>
                </div>
              </b-progress-bar>
            </b-progress>
          </div>

          <!-- <div 
            class="border 
bg-pollresult mt-3 bg-pollresult flex justify-between items-center"
          >
            <div class="py-3 w-3/5 bg-primary-darktransparent">
              <p class="text-lg font-medium pl-3">{{ "item.polloption4" }}</p>
            </div>
            <div class="">
              <p class="text-lg font-medium pr-3">{{ "item.pollresult4" }}</p>
            </div>
          </div> -->
        </div>
        <!-- <div class="cust-divider my-8"></div> -->
        <!-- <div class="flex items-center">
          <img alt="user" class="w-9 rounded-full" :src="item.userImg" />
          <p class="font-bold text-sm ml-4">
            {{ item.userName }}
          </p>
        </div> -->
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      value: 50,
    };
  },
  methods: {
    calculatePercent(votes) {
      return parseInt((votes / this.data.poll.totalVotes) * 100);
    },
  },
};
</script>
